import React, { useState } from 'react';
import {
  TextField,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Stack,
  Box,
  FormLabel,
} from '@mui/material';
import { ContactType } from './types';

interface Props {
  contact: ContactType;
  handleChange: (e: any, value: any) => void;
  isTitle?: boolean;
  errors: { [key: string]: string };
  errorKey: string;
}

const Contact = (props: Props) => {
  const [emailError, setEmailError] = useState('');

  const handlePreferredMethodChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value as 'phone' | 'email';
    props.handleChange('preferredMethod', value);
  };

  const validateEmail = (email: string) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return !email || !emailRegex.test(email)
      ? 'Please enter a valid email address'
      : '';
  };

  const handleEmailBlur = () => {
    const error = validateEmail(props.contact.email);
    setEmailError(error);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.handleChange('email', e.target.value);
    setEmailError('');
  };

  return (
    <Box>
      <Stack
        direction='row'
        justifyContent='space-between'
        spacing={2}
        marginTop={2}
      >
        <TextField
          label='First Name'
          name='firstName'
          value={props.contact.firstName}
          onChange={(e) => props.handleChange('firstName', e.target.value)}
          fullWidth
          margin='normal'
          sx={{ backgroundColor: '#fff' }}
          helperText={props.errors?.firstName || ''}
          error={Boolean(props.errors?.[`${props.errorKey}FirstName`])}
          required
        />
        <TextField
          label='Last Name'
          name='lastName'
          value={props.contact.lastName}
          onChange={(e) => props.handleChange('lastName', e.target.value)}
          fullWidth
          margin='normal'
          sx={{ backgroundColor: '#fff' }}
          helperText={props.errors?.lastName || ''}
          error={Boolean(props.errors?.[`${props.errorKey}LastName`])}
          required
        />
      </Stack>
      <Stack
        direction='row'
        justifyContent='space-between'
        spacing={2}
        marginTop={2}
      >
        <TextField
          label='Phone'
          name='phone'
          value={props.contact.phone}
          onChange={(e) => props.handleChange('phone', e.target.value)}
          fullWidth
          margin='normal'
          sx={{ backgroundColor: '#fff' }}
          type='tel'
          onInput={(e) => {
            const input = e.target as HTMLInputElement;
            input.value = input.value.replace(/[^0-9]/g, '');
          }}
          helperText={props.errors?.phone || ''}
          error={Boolean(props.errors?.[`${props.errorKey}Phone`])}
          required
        />
        <TextField
          label='Ext'
          name='ext'
          value={props.contact.ext}
          onChange={(e) => props.handleChange('ext', e.target.value)}
          fullWidth
          margin='normal'
          sx={{ backgroundColor: '#fff' }}
        />
      </Stack>
      <Stack
        direction='row'
        justifyContent='space-between'
        spacing={2}
        marginTop={2}
      >
        {props.isTitle && (
          <TextField
            label='Title'
            name='title'
            value={props.contact.title}
            onChange={(e) => props.handleChange('title', e.target.value)}
            fullWidth
            margin='normal'
            sx={{ backgroundColor: '#fff' }}
          />
        )}
        <TextField
          label='Email'
          name='email'
          value={props.contact.email}
          onChange={handleEmailChange}
          onBlur={handleEmailBlur}
          fullWidth
          margin='normal'
          sx={{ backgroundColor: '#fff' }}
          helperText={emailError || ''}
          error={Boolean(props.errors?.[`${props.errorKey}Email`])}
          required
        />
      </Stack>
      <FormControl component='fieldset' margin='normal' sx={{ marginTop: 4 }}>
        <FormLabel component='legend'>Preferred Method of Contact</FormLabel>
        <RadioGroup
          name='preferredMethod'
          value={props.contact.preferredMethod ?? ''}
          onChange={handlePreferredMethodChange}
          row
        >
          <FormControlLabel value='phone' control={<Radio />} label='Phone' />
          <FormControlLabel value='email' control={<Radio />} label='Email' />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default Contact;
